




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIREGISTRATIONCONFIRM= createAsyncThunk(
  "AlumniRegistratioConfirm/AlumniRegistratioConfirm",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniRegistratioConfirmSlice = createSlice({
  name: "AlumniRegistratioConfirmSlice",
  initialState: {
    AlumniRegistratioConfirm: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniRegistratioConfirm: (state) => {
        state.AlumniRegistratioConfirm.loading = false
        state.AlumniRegistratioConfirm.error = false
        state.AlumniRegistratioConfirm.data = []
        state.AlumniRegistratioConfirm.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIREGISTRATIONCONFIRM.fulfilled, (state, action) => {
      state.AlumniRegistratioConfirm = {
        ...state.AlumniRegistratioConfirm,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIREGISTRATIONCONFIRM.pending, (state, action) => {
      state.AlumniRegistratioConfirm = {
        ...state.AlumniRegistratioConfirm,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIREGISTRATIONCONFIRM.rejected, (state, action) => {
      state.AlumniRegistratioConfirm = {
        ...state.AlumniRegistratioConfirm,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniRegistratioConfirmAction = {
    ALUMNIREGISTRATIONCONFIRM,
};

export { AlumniRegistratioConfirmAction };
export default AlumniRegistratioConfirmSlice.reducer;
export const {setInitialStateOfAlumniRegistratioConfirm} = AlumniRegistratioConfirmSlice.actions
